module.exports = __webpack_public_path__ + "img/车辆换电信息.cffa2f7c.png";